<template>
  <v-container>
    <v-card outlined :loading="loadingMain" :disabled="loadingMain">
      <v-toolbar flat>
        <v-toolbar-title>Orçamento Cronograma Financeiro (Orçamento)</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <!-- <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" small dark fab v-bind="attrs" v-on="on">
              <v-icon>mdi-hammer-wrench </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="getExportExcel()">
              <v-list-item-title>
                <v-icon class="mr-2"> mdi-file-excel </v-icon>
                Exportar Excel
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu> -->

        <v-spacer></v-spacer>

        <v-btn
          large
          class="ml-2"
          color="primary"
          rounded
          @click="showSyntheticSchedule()"
        >
          Cronograma Sintético
        </v-btn>
      </v-toolbar>

      <!-- ETAPAS  -->
      <!-- <div v-for="(stage, index) in stages" :key="index">
        <div class="title_table">
          <div style="float: left">
            {{ stage.stage.code + " - " + stage.stage.name }}
          </div> -->
          <!-- <div style="float: right">
            <v-btn small color="primary" @click="showDialogScheduleStage(stage)">
              <v-icon dark>mdi-pencil</v-icon>
            </v-btn>
          </div> -->
          <!-- <div style="float: right">Total: {{ calcTotal(stage[0].id) }}</div> -->
        <!-- </div> -->
        <!-- COMPOSICOES -->
        <v-card elevation="0" tile>
          <v-simple-table dense outlined>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">SERVIÇO</th>
                  <th class="text-center">DATA</th>

                  <th class="text-right">TOTAL</th>
                  <th class="text-right"></th>
                  <!-- <th class="text-right" style="white-space: nowrap">% REALIZADO</th>
                  <th class="text-right" style="width: 100px; white-space: nowrap">
                    HH REALIZADO
                  </th>
                  <th class="text-right" style="white-space: nowrap">A REALIZAR</th>
                  <th class="text-right" style="width: 50px; white-space: nowrap"></th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(stage, index) in stages" :key="index">
                  <td> {{stage.stage.code}}- {{ stage.stage.name }}</td>
                  <td style="width: 200px" class="text-center">
                    <div>
                      {{ formatDate(stage.date_start_orc) }} - {{ formatDate(stage.date_end_orc) }}
                    </div>
                  </td>

                  <td style="width: 150px" class="text-right">
                    <div class="float-right">
                      {{ formatMoney(stage.total) }}
                    </div>
                  </td>

                  <td class="text-right">
                    <div style="text-wrap: nowrap">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="showDialogSchedule(stage)"
                            v-bind="attrs"
                            v-on="on"
                            icon
                            color="primary"
                            ><v-icon>mdi-pencil</v-icon></v-btn
                          >
                        </template>
                        <span>Cronograma</span>
                      </v-tooltip>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>

    </v-card>
    <DialogSchedule
    v-model="dialogSchedule"
    @updatePhysicalSchedule="updatePhysicalSchedule"
    :financial_schedule="financialSchedule"
    />
  </v-container>
</template>

<script>
import DialogSchedule from "./components/DialogSchedule.vue";
import { mapActions } from "vuex";
export default {
    components: {
        DialogSchedule
    },
data() {
    return {
        dialogSchedule: false,
        loadingMain: false,
        stages: [],
        financialSchedule: null,
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    ...mapActions("BudgetFinancialSchedule", ["index"]),
    initialize() {
      this.loadingMain = true;

      this.index()
        .then((response) => {
          this.stages = response.data;
        })
        .catch(() => {
          this.$toast.error("Não foi possível carregar as etapas");
        })
        .finally(() => {
          this.loadingMain = false;
        });
    },
    updatePhysicalSchedule(stage){
      this.stages = this.stages.map(item => {
        if(item.id === stage.id){
          return stage;
        }
        return item;
      });
    },
    showDialogSchedule(item){
      this.dialogSchedule = true;
      this.financialSchedule = item;
    },
    showSyntheticSchedule(){
        this.$router.push({ name: 'budget_finacial_synthetic_schedule' });
    },
    formatDate(date) {
      if (date) {
        let date_split = date.split("-");
        return date_split[2] + "/" + date_split[1] + "/" + date_split[0];
      }
      return "";
    },
    formatMoney(number) {
      number = this.parseNumber(number);
      return number.toLocaleString("pt-br", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    parseNumber(number) {
      if (isNaN(number)) {
        return 0;
      }
      let result = parseFloat(number);
      return result;
    },
}

};
</script>

<style scoped></style>
